import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { PERSIST_KEYS } from '@app/app/persist/persist-keys';

type Store = {
  accounts: Set<string>;
};

type Actions = {
  addAccountId: (newAccountId: string) => void;
};

type PersistedState = {
  accounts: string[];
};

const defaultState: Store = {
  accounts: new Set(),
};

export const usePersistedAccountsStore = create<Store & Actions>()(
  persist(
    immer((set) => ({
      ...defaultState,
      addAccountId: (newAccountId) =>
        set((state) => {
          if (!newAccountId) return;
          state.accounts.add(newAccountId);
        }),
    })),
    {
      name: PERSIST_KEYS.ACCOUNTS_IDS,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        accounts: Array.from(state.accounts),
      }),
      // Array → Set
      merge: (persistedState, currentState) => {
        const parsed = persistedState as PersistedState;
        return {
          ...currentState,
          accounts: new Set(parsed.accounts),
        };
      },
    },
  ),
);
